import React, { useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Typography from "@material-ui/core/Typography";
import { useHistory } from "react-router-dom";

import { useTranslation } from "react-i18next";
import api from "../../utils/api";

import styles from "./Security.module.css";

// need to padd user from props index.jsx ?
const SecurityPage = ({ user }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [mfa, setMfa] = useState(user?.customer?.enforceMfa);
  const handleCheckboxChange = async () => {
    const newMfa = !mfa;
    const mfaValue = newMfa ? 1 : 0;
    const options = { body: JSON.stringify({ enforceMfa: newMfa }) };
    await api.put(
      `customer/mfa/${user?.customer?.id}/${mfaValue}`,
      options,
      history
    );
    // if (updatedMfa == true) {
    //   setMfa(!mfa);
    // }
    setMfa(!mfa);
  };
  return (
    <div className={styles.pageWrapper}>
      <Typography
        align="left"
        color="white"
        variant="h4"
        className={styles.title}
      >
        {t("Security")}
      </Typography>
      <FormGroup className={styles.checkboxMargin}>
        <FormControlLabel
          control={<Checkbox checked={mfa} onChange={handleCheckboxChange} />}
          label="Enforce all users to use Multi-Factor Authentication (MFA)"
        />
      </FormGroup>
    </div>
  );
};
export default SecurityPage;
